module.exports = __webpack_public_path__ + "static/Syrenis-c2d0c1759268e3fb63ea8e51dc44004c.jpg";